import { render, staticRenderFns } from "./OrderComponent.vue?vue&type=template&id=415f3218&scoped=true&"
import script from "./OrderComponent.vue?vue&type=script&lang=js&"
export * from "./OrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponent.vue?vue&type=style&index=0&id=415f3218&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f3218",
  null
  
)

export default component.exports